import React, {useEffect} from 'react';
import {usePhaseState} from 'funnel-schedule/phase-context';
import {DateTime} from 'luxon';
import SalesIndex from './impact';
import track from 'utils/track';

export default function (props) {
  const {
    phases: {
      sales: salesSchedule = {
        phase: 'during',
        salesEnd: ''
      }
    }
  } = usePhaseState();

  useEffect(() => {
    track('Product Viewed', {
      product_id: 'HF-FF-IK',
      sku: 'HF-FF-IK',
      name: 'Fantastic Fungi Impact Kit',
      variant: salesSchedule.phase != 'during' ? 'ff-impactkit' : 'ff-impactkit-launch',
      value: salesSchedule.phase != 'during' ? 197 : 97,
      currency: 'usd'
    });
  }, [salesSchedule.phase]);

  const salesTimeOverride = new Date(salesSchedule.salesEnd).getTime();

  return (
    <SalesIndex
      ctaOverride={salesSchedule.phase != 'during' ? 'sales197' : 'sales97'}
      videoUrlOverride={
        salesSchedule.phase != 'during'
          ? 'https://www.youtube.com/watch?v=ASk8aVfPN8A'
          : 'https://www.youtube.com/watch?v=uj_LUZcJYeE'
      }
      timerOverride={salesTimeOverride}
    />
  );
}
